import { render, staticRenderFns } from "./Agriculture.vue?vue&type=template&id=32e3e475&scoped=true"
import script from "./Agriculture.vue?vue&type=script&lang=js"
export * from "./Agriculture.vue?vue&type=script&lang=js"
import style0 from "./Agriculture.vue?vue&type=style&index=0&id=32e3e475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3e475",
  null
  
)

export default component.exports